//@ts-nocheck
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Pagination,
  Typography,
} from "@mui/material";
import { OidcIdentityContext } from "@rsmus/react-auth";
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  Item,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";
import "devextreme/data/odata/store";
import { isEmpty, isNull } from "lodash";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
} from "recoil";
import {
  ArchiveSitesDTO,
  MDMLegalEntityDTO,
  ServiceBusEnum,
  SiteConfig,
} from "../../api-client-nswag/taxportal-client";
import { taxPortalClientApi, createSitesClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import { defaultPageSize } from "../../constants";
import AppNameToggle, {
  getAppName,
} from "../../cui/commonComponents/AppNameToggle";
import SplitButton from "../../cui/commonComponents/SplitButton";
import useSnackbar from "../../hooks/useSnackbar";
import { SnackbarMessage } from "../../hooks/useSnackbar.types";
import { envProperties } from "../../util/EnvironmentProperties";
import { calculateGridHeight, convertUTCTimeToLocal } from "../../util/Utils";
import { DialogBox } from "./DialogBox";
import { clientData } from "./pages/Addclients";
import LegalEntitesEditPermission from "./selectClientAndTemplate/LegalEntitesEditPermission";
import ModifyDates, {
  storeModifiedDatesForCS,
} from "./selectClientAndTemplate/ModifyDates";
import ModifySiteName from "./selectClientAndTemplate/ModifySiteName";
import SelectClientAndTemplate, {
  PermissionDataType,
} from "./selectClientAndTemplate/SelectClientAndTemplate";
import SelectClientAndTemplateForIS from "./selectClientAndTemplate/SelectClientAndTemplateForIS";
import {
  storeEndValueForCS,
  storeStartValueForCS,
} from "./selectClientAndTemplate/SelectDates";
import SelectEditLegalEntities from "./selectClientAndTemplate/SelectEditLegalEntities";
import { storeTaxyear } from "./selectClientAndTemplate/SelectTaxYear";
import { SiteHistory } from "./siteHistory/SiteHistory";
import { selectedRowDataTypes } from "./types";

interface selectedOptionType {
  value: number;
  label: string | undefined;
}
interface gridLegalEntityType {
  pending: boolean;
  fulfilled: boolean;
  gridLegalData: MDMLegalEntityDTO[];
}

export const getSiteCreationResponse = atom({
  key: "getSiteCreationResponse",
  default: false,
});

export const getSiteExistResponse = atom({
  key: "getSiteExistResponse",
  default: "",
});

export const getTaxYearResponse = atom({
  key: "getTaxYearResponse",
  default: null,
});

export const getTaxYearResponseForCS = atom({
  key: "getTaxYearResponseForCS2",
  default: null,
});

export const getSiteIdForRow = atom({
  key: "getSiteIdForRow",
  default: null,
});

export interface getSites {
  pending: boolean;
  data: GetAllSitesInfoDTO[] | undefined;
  totalCount: number;
}

export default function SitesWithLegalEntities() {
  const dataGridRef = useRef(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [ds, setDs] = useState([]);
  const [data, setData] = useState<getSites>({
    pending: true,
    data: [],
    totalCount: 0,
  });
  const selection = useRecoilValue(clientData);
  const [selectedData, setSelectedData] = useState([]);
  const [tab, setTab] = useState(1);
  const { showSnackbar } = useSnackbar();
  const { showSuccessSnackbar } = useSnackbar();
  const { user } = useContext(OidcIdentityContext);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [selectedOption, setSelectedOption] =
    useState<selectedOptionType | null>(null);
  const [title, setTitle] = useState("");
  const appName = useRecoilValue(getAppName);
  const [btnContinueDisable, setBtnContinueDisable] = useState(false);
  const [activeDiv, setActiveDiv] = useState(null);
  const [isDisplayModal, setIsDisplayModal] = useState(false);
  const [isDisplaySiteSettings, setisDisplaySiteSettings] = useState(false);
  const [isDisplayLegalEntities, setisDisplayLegalEntities] = useState(false);
  const [isDisplaySiteName, setIsDisplaySiteName] = useState(false);
  const [isDisplayDates, setisDisplayDates] = useState(false);
  const [isDisplayTaxYear, setisDisplayTaxYear] = useState(false);
  const [taxYear, setTaxYear] = useRecoilState<any>(getTaxYearResponse);
  const [taxYearForCS, setTaxYearForCS] = useRecoilState<any>(
    getTaxYearResponseForCS
  );
  const [checked, setChecked] = useState(false);
  const [isChecked, setisChecked] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string | null | undefined>(null);
  const [handleEdit, sethandleEdit] = useState(false);
  const removeTaxYear = useResetRecoilState(getTaxYearResponse);
  const removeTaxYearForCS = useResetRecoilState(getTaxYearResponseForCS);
  const removeStoredYear = useResetRecoilState(storeTaxyear);
  const removeStoredStartYear = useResetRecoilState(storeStartValueForCS);
  const removeStoredEndYear = useResetRecoilState(storeEndValueForCS);
  const [siteDates, setSiteDates] = useState<SiteConfig>();
  const modifyDates = useRecoilValue<string>(storeModifiedDatesForCS);
  const [selectedLegalEntityData, setSelectedLegalEntityData] = useState<any[]>(
    []
  );
  const [removedLegalEntityData, setRemovedLegalEntityData] = useState<any[]>(
    []
  );
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [pageNumber, setpageNumber] = useState(1);
  const [legalData, setLegalData] = useState<gridLegalEntityType>({
    pending: false,
    fulfilled: false,
    gridLegalData: [],
  });
  const [isFlag, setIsFlag] = useRecoilState(getSiteCreationResponse);
  const [siteConfig, setSiteConfig] = useState<SiteConfig>({});
  const [siteExistResponse, setIsSiteExistResponse] =
    useRecoilState(getSiteExistResponse);
  const [handleRemoveSiteSettings, setHandleRemoveSiteSettings] =
    useState(false);
  const [popup, setPopup] = useState(false);
  const [id, setId] = useRecoilState<number>(getSiteIdForRow);
  const [dataPermissionFinal, setDataPermissionFinal] = useState<
    PermissionDataType[]
  >([
    {
      mdmClientId: 0,
      clientId: 0,
      clientName: "",
      hqSiteId: 0,
      hqClientName: "",
      suppressFolderCreation: false,
      suppressDropdown: false,
      suppressProjectStatus: false,
      userName: "",
    },
  ]);
  const [editDataPermissionFinal, seteditDataPermissionFinal] = useState<
    PermissionDataType[]
  >([
    {
      mdmClientId: 0,
      clientId: 0,
      clientName: "",
      hqSiteId: 0,
      hqClientName: "",
      suppressFolderCreation: false,
      suppressDropdown: false,
      suppressProjectStatus: false,
      userName: "",
      isTestSite: null,
      isPDCEnabled: null,
    },
  ]);
  const [selectionMode, setSelectionMode] = useState("multiple");
  const [selectedRowsData, setSelectedRowsData] =
    useState<selectedRowDataTypes | null>(null);

  const [siteNameForIS, setsiteNameForIS] = useState("");
  const [isAllSiteSelected, setIsAllSiteSelected] = useState(false);
  const [disableEditButon, setDisableEditButton] = useState(false);


  const CONSENT_LOOKUP_DATA = Object.freeze([
        { value: "CONSENT", display: "Y" },
        { value: "NO_CONSENT", display: "N" },
        { value: "MIXED_CONSENT", display: "Mixed" },
    ]);   

    const consentLookup = useMemo(
        () => ({
            dataSource: CONSENT_LOOKUP_DATA,
            valueExpr: "value",
            displayExpr: "display",
        }),
        []
    );
  // Function to handle div click
  const handleDivClick = (divNumber) => {
    setpageNumber(1);
    setActiveDiv(divNumber);
  };
  const [isAllLegalEntitySelected, setIsAllLegalEntitySelected] = useState(false);
  const fetchData = async () => {
    try {
      setData({ pending: true, data: [], totalCount: 0 });
      const startIndex =
        pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
      const data = await createSitesClientApi.highQ_GetSiteFromTrack(
        activeDiv,
        appName !== null ? appName : "PERF",
        startIndex,
        defaultPageSize
      );
      const rawData = data?.data?.data || [];
      const uniqueData = rawData.map((item) => ({
        ...item,
        // Normalize to a strict boolean: true only when truthy-true, null/undefined/false all become false
        isCustomPermissionApplied: item.isCustomPermissionApplied === true,
      }));
      setData({ pending: false, data: uniqueData, totalCount: data?.data?.totalCount });
    } catch (error) { }
  };

  const fetchDataBySearch = async () => {
    try {
      setData({ pending: true, data: [], totalCount: 0 });
      const startIndex =
        pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
      const data = await createSitesClientApi.highQ_GetSiteFromTrackSearch(
        activeDiv,
        searchTerm,
        appName !== null ? appName : "PERF"
      );
      const rawData = data?.data?.data || [];
      const uniqueData = rawData.map((item) => ({
        ...item,
        // Normalize to a strict boolean: true only when truthy-true, null/undefined/false all become false
        isCustomPermissionApplied: item.isCustomPermissionApplied === true,
      }));
      setData({ pending: false, data: uniqueData, totalCount: data.totalCount });
    } catch (error) { }
  };

  useEffect(() => {
    if ((searchTerm === null || searchTerm?.length === 0) && shouldFetch) {
      fetchData();
      setShouldFetch(false);
    }
  }, [activeDiv, searchTerm, pageNumber, appName, shouldFetch]);

  useEffect(() => {
    setpageNumber(1);
    setShouldFetch(true);
  }, [appName, activeDiv]);

  useEffect(() => {
    setShouldFetch(true);
  }, [pageNumber, searchTerm]);

  useEffect(() => {
    if (!isNull(searchTerm) && !isEmpty(searchTerm)) {
      fetchDataBySearch();
    }
    // eslint-disable-next-line
  }, [activeDiv, appName, pageNumber, searchTerm]);

  useEffect(() => {
    if (tab === 1) {
      setTitle("Select Client and Template");
    }
    if (tab === 2) {
      // if (appName === "TP")
      //   setTitle("Select Tax Year")
      // if (appName === "CS")
      setTitle("Select Dates");
    }
    if (tab === 3) {
      setTitle("Select Legal Entities");
    }
    if (tab === 4) {
      setTitle("Select Legal Entities Settings");
    }
    if (tab === 5) {
      setTitle("Customize site name");
    }
  }, [tab]);

  const onSelectionchanged = (e: any) => {
    setSelectedData(e.selectedRowsData);
    if (
      e?.selectedRowsData[0]?.isTestSite === undefined ||
      e?.selectedRowsData[0]?.isTestSite === null ||
      e?.selectedRowsData[0]?.isTestSite === false
    ) {
      setisChecked(false);
    } else {
      setisChecked(e?.selectedRowsData[0]?.isTestSite);
    }
  };
  const datetime = (e: any) => {
    if (e.data.created === null) {
      return null;
    } else {
      return (
        <div style={{ display: "flex" }}>
          <div>
            <div>{convertUTCTimeToLocal(e.data.created)}</div>
          </div>
        </div>
      );
    }
  };

  const cellRender = (e: any) => {
    if (e.data.created === null) {
      return null;
    } else {
      return (
        <div style={{ display: "flex" }}>
          <div>
            <div>{convertUTCTimeToLocal(e.data.archivedDate)}</div>
          </div>
        </div>
      );
    }
  };
  const cellRenderRestore = (e: any) => {
    return <div>{convertUTCTimeToLocal(e.data.restoredDate)}</div>;
  };
  const cellRenderForMessage = (e: any) => {
    if (e.data.message === null && e.data.status === null) {
      return null;
    }
    return <div title={e.data.message}>{e.data.status}</div>;
  };

  const cellRenderForClientType = (e: any) => {
    const { isProspectClientSite } = e.data;
    if (isProspectClientSite === null || isProspectClientSite === undefined) {
      return null;
    }
    return <div>{isProspectClientSite ? "Prospect" : "Client"}</div>;
  };

  const SiteId = selectedData.map((e) => {
    return e.hqSiteId;
  });
  const refreshButtonOptions = {
    icon: "refresh",
    onClick: async () => {
      setSearchTerm(null);
      if (dataGridRef.current) {
        dataGridRef.current.instance.clearFilter();
      }
      fetchData();
    },
  };
  const onRemoveMapping = async () => {
    try {
      showSnackbar({ message: SnackbarMessage.REMOVE_MAPPING });
      var siteDetails: ArchiveSitesDTO = {
        userName: user?.profile.preferred_username,
        siteIds: SiteId,
      };
      var response = await createSitesClientApi.taxPortal_ArchiveSites(
        siteDetails
      );
      if (response.isSuccess === true) {
        showSuccessSnackbar({
          message: SnackbarMessage.REMOVE_MAPPING_SUCCESS,
        });
      } else {
        showSnackbar({
          message: `${SnackbarMessage.REMOVE_MAPPING_FAIL} ${response.message}`,
          severity: "error",
        });
      }
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };

  const onUnarchive = async () => {
    try {
      showSnackbar({ message: SnackbarMessage.UNARCHIVE_SITE });
      var siteDetails: ArchiveSitesDTO = {
        userName: user?.profile.preferred_username,
        siteIds: SiteId,
      };
      var response = await createSitesClientApi.taxPortal_UnarchiveSites(
        siteDetails
      );
      for (var i = 0; i < response?.length; i++) {
        var splitResponse = response[i].split(",");
        if (splitResponse[1] === "Site Exists") {
          showSnackbar({
            message: splitResponse[0] + SnackbarMessage.SITE_EXISTS,
          });
        } else if (response[i] === "Unarchived Successfully") {
          showSuccessSnackbar({ message: SnackbarMessage.UNARCHIVE_SUCCESS });
        } else if (splitResponse[1] === "Organization Exists") {
          await delay(2000);
          showSnackbar({
            message: splitResponse[0] + SnackbarMessage.ORGANIZATION_EXISTS,
          });
        } else {
          showSnackbar({
            message: SnackbarMessage.UNARCHIVE_FAIL,
            severity: "error",
          });
        }
      }
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };
  const onAddClientId = async () => {
    try {
      showSnackbar({ message: SnackbarMessage.ADDCLIENTID_SITENAME });
      const userName = user?.profile.preferred_username;
      var response = await createSitesClientApi.highQ_UpdateSiteNameWithClientId(
        SiteId,
        appName,
        userName
      );
      for (var i = 0; i < response?.length; i++) {
        if (response[i] === "ClientId Added Successfully") {
          showSuccessSnackbar({ message: SnackbarMessage.ADDCLIENTID_SUCCESS });
        } else {
          await delay(2000);
          showSnackbar({
            message: response[i],
            severity: "error",
          });
        }
      }
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };

  const onClickRetrySiteCreationWithSelection = async () => {
    try {
      showSuccessSnackbar({ message: SnackbarMessage.RETRY_FOR_SITE_CREATION });
      const selectedData = dataGridRef.current!.instance.getSelectedRowsData();
      const messageForRetry = selectedData.map((e: any) => {
        return {
          siteId: 0,
          userName: user?.profile.preferred_username,
          siteName: e.name,
          clientName: e.clientName,
          mdmClientId: e.mdmClientId,
        };
      });
      if (messageForRetry != null) {
        var response = await createSitesClientApi.siteSetUp_CreateSiteVerify(
          appName,
          messageForRetry
        );
      }
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };

  const uniqueTags = [];
  data?.data?.map((x) => {
    if (uniqueTags.indexOf(x.name) === -1) {
      uniqueTags.push(x.name);
    }
  });

  const onSelect = (e: string) => {
    switch (e) {
      case "ADD":
        setIsDisplayModal(true);
        break;
      case "Site Settings":
        setisDisplaySiteSettings(true);
        break;
      case "Legal Entities":
        setisDisplayLegalEntities(true);
        break;
      case "Update Start and End Dates":
        setId(selectedData[0].hqSiteId);
        setisDisplayDates(true);
        break;
      case "Site Name":
        setIsDisplaySiteName(true);
        break;
    }
  };

  const onSelectForIsheet = async (e: string) => {
    const isheetTypeMap: { [key: string]: string } = {
      "Sync Isheets": "Sync Isheet",
      "Sync Information Request Isheet": "Information Request List",
      "Sync Document Metadata Isheet": "Documents Metadata",
      "Sync Folder Metadata Isheet": "Folder metadata",
      "Sync ISheet IManage Folder": "IManage Folder",
    };
    const isheetType = isheetTypeMap[e] || "";
    try {
      await taxPortalClientApi.taxPortal_UpdateIsheetDataTrigger(
        SiteId,
        isheetType
      );
    } catch (error) {
      console.log(error);
    }
  };
  const onHistorySelect = (e: string) => {
    setIsHistoryOpen(true);
  };

  const SubmitSiteSettings = async () => {
    showSnackbar({
      message: SnackbarMessage.SITE_SETTINGS_EDIT_SUCCESS,
    });
    var response = await createSitesClientApi.mDM_UpdateSelectedLegalEntities(
      editDataPermissionFinal,
      selectedData[0].hqSiteId,
      appName
    );
    setisDisplaySiteSettings(false);
    sethandleEdit(false);
    setPopup(false);
    setLegalData({ gridLegalData: [] });
  };
  const handleClose = () => {
    setIsDisplayModal(false);
    setTab(1);
    setSelectedOption(null);
    setSelectionMode("multiple");
    setIsFlag(false);
    setsiteNameForIS("");
    setChecked(false);
    setisChecked(false);
    removeTaxYearForCS();
    removeTaxYear();
    removeStoredYear();
    removeStoredStartYear();
    removeStoredEndYear();
    localStorage.clear();
  };
  const handleCloseLegalEntites = () => {
    setisDisplayLegalEntities(false);
    setLegalData({ gridLegalData: [] });
    setSelectedOption(null);
    setSelectionMode("multiple");
    setIsFlag(false);
    sethandleEdit(false);
    setSelectionMode("multiple");
    localStorage.clear();
  };
  const handleCloseSiteSettings = () => {
    setisDisplaySiteSettings(false);
    setHandleRemoveSiteSettings(false);
    setLegalData({ gridLegalData: [] });
    setSelectedOption(null);
    sethandleEdit(false);
    localStorage.clear();
  };
  const handleCloseSiteName = () => {
    setIsDisplaySiteName(false);
    setLegalData({ gridLegalData: [] });
    setSelectedOption(null);
    sethandleEdit(false);
    localStorage.clear();
  };
  const handleChange = (e: boolean) => {
    setisChecked(e);
  };
  const handleCloseDates = () => {
    setisDisplayDates(false);
    //setLegalData({ gridLegalData: [] });
    setSelectedOption(null);
    sethandleEdit(false);
    localStorage.clear();
  };
  const dropdownSuppression = dataPermissionFinal?.filter(item => item.suppressDropdown
    === true && item.clientId != null).map(item => item.clientId);

  const folderSuppression = dataPermissionFinal?.filter(item => item.suppressFolderCreation
    === true && item.clientId != null).map(item => item.clientId);

  const projectStatusSuppression = dataPermissionFinal?.filter(item => item.suppressProjectStatus
    === true && item.clientId != null).map(item => item.clientId);

  const listData =
  {
    hqSiteId: 0,
    user: user?.profile.preferred_username as string,
    id: null,
    requestType: "Create Site",
    scriptId: null,
    statusId: null,
    masterClientId: selectedRowsData?.mdmClientId,
    templateId: selectedOption?.value?.toString(),
    siteName: dataPermissionFinal[0]?.hqClientName,
    appName: appName !== null ? appName : "PERF",
    taxYearStartDate: siteConfig?.startDate !== undefined ? siteConfig.startDate : null,
    taxYearEndDate: siteConfig?.endDate !== undefined ? siteConfig.endDate : null,
    includeAllEntities: isAllLegalEntitySelected ? "Yes" : "No",
    filesProcessValidationId: null,
    selectedLegalEntities: [],
    suppressDropdown: dropdownSuppression,
    suppressFolderCreation: folderSuppression,
    suppressProjectStatus: projectStatusSuppression,
    isTestSite: isChecked,
    creationSource: "",
    isProspect: appName === "PERF" ? false : selectedRowsData?.isProspect,
  };


  const listDataForIS = {
    hqSiteId: 0,
    user: user?.profile.preferred_username as string,
    id: null,
    requestType: "Create Site",
    scriptId: null,
    statusId: null,
    masterClientId: 0,
    templateId: selectedOption?.value?.toString(),
    siteName: siteNameForIS,
    appName: appName !== null ? appName : "PERF",
    taxYearStartDate: siteConfig?.startDate !== undefined ? siteConfig.startDate : null,
    taxYearEndDate: siteConfig?.endDate !== undefined ? siteConfig.endDate : null,
    includeAllEntities: isAllLegalEntitySelected ? "Yes" : "No",
    filesProcessValidationId: null,
    selectedLegalEntities: [],
    suppressDropdown: [],
    suppressFolderCreation: [],
    suppressProjectStatus: [],
    isTestSite: isChecked,
    creationSource: "",
    isProspect: appName === "PERF" ? false : selectedRowsData?.isProspect,
    };

  const handleContinueForIS = async () => {
    if (tab === 1) {
      setTab(tab + 1);
    }
    if (tab === 2) {
      setTab(tab + 1);
    }
    if (tab === 3 && appName === "IS") {
      try {
        const response = await createSitesClientApi.taxPortal_CreateSites(
          listDataForIS
        );
        setIsSiteExistResponse(response);
        handleClose();
      } catch (error) {
        console.log(error, "error");
      }
    }
  };
  const handleContinue = async () => {
    if (tab === 5 && tab < 6) {     
      if (selectionMode === "none") {
        try {
         setIsAllLegalEntitySelected(true);
         listData['includeAllEntities'] = "Yes";
          const response = await createSitesClientApi.taxPortal_CreateSites(
            listData
          );
          const isExists = !isNull(response) && !isEmpty(response);
          if (isExists) {
            setIsFlag(true);
            setIsSiteExistResponse(response);
          } else {
            setIsDisplayModal(false);
            handleClose();
            setIsFlag(false);
            setChecked(false);
            setisChecked(false);
            localStorage.clear();
          }
        } catch (error) { }
        localStorage.clear();
      } else {
        try {

          listData['selectedLegalEntities'] = dataPermissionFinal?.map(item => item.clientId);
          setIsAllLegalEntitySelected(false);
          listData['includeAllEntities'] = "No";
          const response = await createSitesClientApi.taxPortal_CreateSites(
            listData
          );
          const isExists = !isNull(response) && !isEmpty(response);
          if (isExists) {
            setIsFlag(true);
            setIsSiteExistResponse(response);
          } else {
            setIsDisplayModal(false);
            handleClose();
            setIsFlag(false);
            setChecked(false);
            setisChecked(false);
            localStorage.clear();
          }
        } catch (error) { }
      }
    } else if (tab === 1 || tab === 2) {
      setTab(tab + 1);
    } else if (tab === 3 || tab === 4) {
      if (selectionMode === "none") {
        if (appName === "TP" || appName === "PERF") {
          setTab(tab + 2);
        } else if (appName === "CS") {
          setTab(tab + 2);
          if (tab === 4) setTab(tab + 1);
        }
      } else if (selectionMode === "multiple") {
        if (appName === "TP" || appName === "PERF") {
          setTab(tab + 1);
        } else if (appName === "CS") {
          setTab(tab + 2);
          if (tab === 4) setTab(tab + 1);
        }
      }
    }
  };
  const handleContinueLegalEntities = async () => {
    try {
      showSnackbar({
        message: SnackbarMessage.LEGAL_ENTITIES_EDIT_SUCCESS,
      });
      var response =
        await createSitesClientApi.taxPortal_DisassociateLegalEntities(
          editDataPermissionFinal,
          selectedData[0].hqSiteId,
          appName,
          isAllSiteSelected
        );
      setisDisplayLegalEntities(false);
      sethandleEdit(false);
      setLegalData({ gridLegalData: [] });
    } catch (error) {
      showSnackbar({
        message: SnackbarMessage.LEGAL_ENTITIES_EDIT_FAIL,
        severity: "error",
      });
    }
  };
  const handleContinueSiteSettings = async () => {
    var response = await createSitesClientApi.mDM_CheckSettingsChange(
      editDataPermissionFinal,
      selectedData[0].hqSiteId
    );
    if (response.data === true) {
      setPopup(true);
    } else {
      SubmitSiteSettings();
    }
  };
  const handleContinueSiteName = async () => {
    try {
      var response = await createSitesClientApi.highQ_ModifySiteName(
        selectedData[0].hqSiteId,
        editDataPermissionFinal,
        appName
      );
      if (response === true) {
        showSuccessSnackbar({
          message: SnackbarMessage.SITE_NAME_EDIT_SUCCESS,
        });
      } else if (response === false) {
        showSnackbar({
          message:
            editDataPermissionFinal[0].hqClientName +
            SnackbarMessage.SITE_NAME_EXISTS,
          severity: "error",
        });
      }

      setIsDisplaySiteName(false);
      sethandleEdit(false);
      setLegalData({ gridLegalData: [] });
    } catch (error) {
      showSnackbar({
        message: SnackbarMessage.SITE_NAME_EDIT_FAIL,
        severity: "error",
      });
    }
  };

  const handleContinueDates = async () => {
    try {
      const clientDTO: CEMHQClientDTO = {
        hqSiteId: selectedData[0].hqSiteId,
        siteName: selectedData[0]?.clientName,
        clientName: selectedData[0]?.clientName,
        hqClientName: selectedData[0]?.name,
        mdmClientId: selectedData[0]?.mdmClientId,
        appName: appName !== null ? appName : "PERF",
        siteConfig: modifyDates,
      };
      var response =
        await createSitesClientApi.taxPortal_UpdateClientMappingDetails(
          selectedData[0].hqSiteId,
          clientDTO
        );
      setisDisplayDates(false);
      sethandleEdit(false);
    } catch (error) {
      showSnackbar({
        message: SnackbarMessage.SITE_DATES_EDIT_FAIL,
        severity: "error",
      });
    }
  };
  const handleBack = () => {
    if (tab === 5 && selectionMode === "none") {
      setTab(tab - 2);
      setIsFlag(false);
    } else {
      if (appName === "TP" || appName === "PERF") setTab(tab - 1);
      else if (appName === "CS") {
        if (tab === 5) setTab(tab - 2);
        else setTab(tab - 1);
      } else setTab(tab - 1);
      setChecked(false);
      setisChecked(false);
    }
    if (
      tab === 3 &&
      (appName === "TP" || appName === "CS" || appName === "PERF")
    ) {
      setBtnContinueDisable(false);
    }
  };
  const handleEditLegalEntities = () => {
    sethandleEdit(true);
  };
  const handleEditDates = () => {
    sethandleEdit(true);
    setBtnContinueDisable(false);
  };

  const handleNo = () => {
    setisDisplaySiteSettings(true);
    setPopup(false);
  };

  const handleYes = () => {
    try {
      SubmitSiteSettings();
    } catch (error) {
      showSnackbar({
        message: SnackbarMessage.SITE_SETTINGS_EDIT_FAIL,
        severity: "error",
      });
    }
    setisDisplaySiteSettings(false);
    setHandleRemoveSiteSettings(true);
    setPopup(false);
  };
  // const getFilteredAndSortedData = useCallback(() => {
  //   const grid = dataGridRef.current?.instance;
  //   const filterExpr = grid.getCombinedFilter(true);
  //   const dataSource = grid.getDataSource();
  //   const loadOptions = dataSource.loadOptions();

  //   dataSource
  //     .store()
  //     .load({
  //       filter: filterExpr,
  //       sort: loadOptions.sort,
  //       group: loadOptions.group,
  //     })
  //     .then((result) => {
  //       setDs(result);
  //     });
  // }, [dataGridRef]);
  //const searchPanelInputRef = useRef(null);
  const exportButtonOptions = {
    icon: "exportxlsx",
    onClick: async () => {
      try {
        var status =
          activeDiv === null
            ? "All"
            : activeDiv.charAt(0) + activeDiv.slice(1).toLowerCase();
        var response = await createSitesClientApi
          .highQ_ExportToExcelForManageSite(appName, activeDiv)
          .then((res: any) => {
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              appName + "-" + status + " Client Summary.xlsx"
            );
            link.click();
          });
        showSuccessSnackbar({
          message: SnackbarMessage.EXPORT_TO_EXCEL_SUCCESS,
        });
      } catch (error) {
        showSnackbar({
          message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL,
          severity: "error",
        });
      }
    },
  };
  // const getFilteredAndSortedData = () => {
  //   const grid = dataGridRef.current?.instance;
  //   const filterExpr = grid.getCombinedFilter(true);
  //   const dataSource = grid.getDataSource();
  //   const loadOptions = dataSource.loadOptions();

  //   dataSource
  //     .store()
  //     .load({
  //       filter: filterExpr,
  //       sort: loadOptions.sort,
  //       group: loadOptions.group,
  //     })
  //     .then((result) => {
  //       setDs(result);
  //       setTimeout(() => {
  //         // Find the input field within the SearchPanel component
  //         const input = document.querySelector(
  //           ".dx-datagrid-search-panel input"
  //         );
  //         if (input) {
  //           input.focus();
  //         }
  //       }, 100);
  //     });
  // };

  const handleHistoryClose = () => {
    setIsHistoryOpen(false);
  };
  const recordExistResponse = SnackbarMessage.RECORD_EXISTS_POPUP;

  const cellRenderSiteName = (e: any) => {
    return (
      <>
        {" "}
        {e?.row?.data?.hqSiteId === 0 ? (
          <div>{e?.row?.data?.name}</div>
        ) : (
          <div
            style={{
              color: "#009cde",
              textDecoration: "underline",
              cursor: "pointer",
              display: "inline",
            }}
            onClick={() =>
              window.open(
                `${envProperties.reactAppHighQSiteUrl}=${e?.row?.data?.hqSiteId}`
              )
            }
          >
            {e?.row?.data?.name}
          </div>
        )}
      </>
    );
  };

  const cellRenderMasterClientId = (e: any) => {
    return (
      <div
        style={{
          color: "#009cde",
          textDecoration: "underline",
          cursor: "pointer",
          display: "inline",
        }}
        onClick={() =>
          window.open(
            `${envProperties.reactAppMdmClientIdURL}=${e?.row?.data?.mdmClientId}`
          )
        }
      >
        {e?.row?.data?.mdmClientId}
      </div>
    );
  };

  return (
    <div style={{ margin: "16px" }}>
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          margin: "10px 0 10px 0",
        }}
      >
        <h2>Manage Sites</h2>
        <AppNameToggle />
      </div>
      <div style={{ marginRight: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0 10px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "14vw",
              justifyContent: "space-between",
              margin: "10px 0 10px 0",
            }}
          >
            <div
              onClick={() => handleDivClick("ACTIVE")}
              style={{
                cursor: "pointer",
                color: activeDiv === "ACTIVE" ? "#fff" : "black",
                backgroundColor: activeDiv === "ACTIVE" ? "#009cde" : "#eee",
                borderRadius: "15px",
                padding: "5px 12px 5px 12px",
                transition: "background-color 0.3s, color 0.3s",
                marginLeft: "10px",
              }}
            >
              Active
            </div>
            <div
              onClick={() => handleDivClick("ARCHIVED")}
              style={{
                cursor: "pointer",
                color: activeDiv === "ARCHIVED" ? "#fff" : "black",
                backgroundColor: activeDiv === "ARCHIVED" ? "#009cde" : "#eee",
                borderRadius: "15px",
                padding: "5px 12px 5px 12px",
                transition: "background-color 0.3s, color 0.3s",
              }}
            >
              Archived
            </div>
            <div
              onClick={() => handleDivClick(null)}
              style={{
                cursor: "pointer",
                color: activeDiv === null ? "#fff" : "black",
                backgroundColor: activeDiv === null ? "#009cde" : "#eee",
                borderRadius: "15px",
                padding: "5px 12px 5px 12px",
                transition: "background-color 0.3s, color 0.3s",
              }}
            >
              All
            </div>
          </div>
          <Button
            className=""
            disabled={selectedData.length === 1 ? false : true}
            sx={{ height: 35, marginBottom: "10px" }}
            variant="outlined"
            onClick={() => {
              onHistorySelect();
            }}
          >
            History
          </Button>
        </div>
        <DialogBox
          isDisplayModal={isHistoryOpen}
          handleClose={handleHistoryClose}
          title={"Site History"}
          btnContinueDisable={btnContinueDisable}
        >
          <SiteHistory selectedRowData={selectedData[0]}></SiteHistory>
        </DialogBox>
        {appName === "IS" ? (
          <DialogBox
            isDisplayModal={isDisplayModal}
            handleClose={handleClose}
            btnOpenText={tab === 3 ? "Finish" : "Next"}
            title={
              tab === 1
                ? "Select Internal Site Template"
                : tab === 2
                  ? "Select Dates"
                  : tab === 3
                    ? "Customize site name"
                    : ""
            }
            handleContinue={handleContinueForIS}
            btnBackText={tab !== 1 ? "Back" : ""}
            handleBack={handleBack}
            btnContinueDisable={btnContinueDisable}
            isCustomScreen={checked}
            handleChange={handleChange}
          >
            <SelectClientAndTemplateForIS
              tab={tab}
              setSelectedRowsData={setSelectedRowsData}
              selectedOption={selectedOption}
              selectedRowsData={selectedRowsData}
              setSelectedOption={setSelectedOption}
              setBtnContinueDisable={setBtnContinueDisable}
              setDataPermissionFinal={setDataPermissionFinal}
              selectionMode={selectionMode}
              setSelectionMode={setSelectionMode}
              appName={appName}
              setIsFlag={setIsFlag}
              setSiteConfig={setSiteConfig}
              siteConfig={siteConfig}
              siteNameForIS={siteNameForIS}
              setsiteNameForIS={setsiteNameForIS}
              setChecked={setChecked}
            />
          </DialogBox>
        ) : (
          <DialogBox
            isDisplayModal={isDisplayModal}
            handleClose={handleClose}
            btnOpenText={tab === 5 ? "Finish" : "Next"}
            title={title}
            handleContinue={handleContinue}
            btnBackText={tab !== 1 ? "Back" : ""}
            handleBack={handleBack}
            btnContinueDisable={btnContinueDisable}
            isCustomScreen={checked}
            handleChange={handleChange}
          >
            <SelectClientAndTemplate
              tab={tab}
              setSelectedRowsData={setSelectedRowsData}
              selectedOption={selectedOption}
              selectedRowsData={selectedRowsData}
              setSelectedOption={setSelectedOption}
              setBtnContinueDisable={setBtnContinueDisable}
              setDataPermissionFinal={setDataPermissionFinal}
              selectionMode={selectionMode}
              setSelectionMode={setSelectionMode}
              appName={appName}
              setIsFlag={setIsFlag}
              setSiteConfig={setSiteConfig}
              setChecked={setChecked}
              siteConfig={siteConfig}
              isAllLegalEntitySelected={isAllLegalEntitySelected}
              setIsAllLegalEntitySelected={setIsAllLegalEntitySelected}
            />
          </DialogBox>
        )}
        <DialogBox
          isDisplayModal={isDisplayLegalEntities}
          handleClose={handleCloseLegalEntites}
          handleEdit={handleEditLegalEntities}
          btnOpenText={"Save"}
          title={"Select Legal Entities"}
          btnEditText={"Edit"}
          handleContinue={handleContinueLegalEntities}
          btnContinueDisable={btnContinueDisable}
        >
          <SelectEditLegalEntities
            selectedRowsData={selectedData}
            setLegalData={setLegalData}
            legalData={legalData}
            setBtnContinueDisable={setBtnContinueDisable}
            selectedLegalEntityData={selectedLegalEntityData}
            setSelectedLegalEntityData={setSelectedLegalEntityData}
            setSelectionMode={setSelectionMode}
            selectionMode={selectionMode}
            handleEdit={handleEdit}
            setDataPermission={seteditDataPermissionFinal}
            dataPermission={editDataPermissionFinal}
            setIsAllSiteSelected={setIsAllSiteSelected}
            isAllSiteSelected={isAllSiteSelected}
            setRemovedLegalEntityData={setRemovedLegalEntityData}
            removedLegalEntityData={removedLegalEntityData}
          />
        </DialogBox>
        <DialogBox
          isDisplayModal={isDisplaySiteSettings}
          handleClose={handleCloseSiteSettings}
          handleEdit={handleEditLegalEntities}
          btnEditText={"Edit"}
          handleContinue={handleContinueSiteSettings}
          btnOpenText={"Save"}
          title={"Select Legal Entities Settings"}
          btnContinueDisable={false}
          btnEditDisable={disableEditButon}
        >
          <LegalEntitesEditPermission
            setDataPermission={seteditDataPermissionFinal}
            handleEdit={handleEdit}
            dataPermission={editDataPermissionFinal}
            selectedRowsData={selectedData}
            setDisableEditButton={setDisableEditButton}
            hideOthersTab={true}
          />
        </DialogBox>
        <DialogBox
          isDisplayModal={isDisplaySiteName}
          handleClose={handleCloseSiteName}
          handleEdit={handleEditLegalEntities}
          btnEditText={"Edit"}
          handleContinue={handleContinueSiteName}
          btnOpenText={"Save"}
          title={"Customize site name"}
          btnContinueDisable={btnContinueDisable}
          isCustomScreen={true}
          handleChange={handleChange}
          isCheckedValue={isChecked}
        >
          <ModifySiteName
            selectedRowsData={selectedData}
            dataPermission={editDataPermissionFinal}
            setDataPermission={seteditDataPermissionFinal}
            setBtnContinueDisable={setBtnContinueDisable}
            handleEdit={handleEdit}
            isChecked={isChecked}
          />
        </DialogBox>

        <DialogBox
          isDisplayModal={isDisplayDates}
          handleClose={handleCloseDates}
          handleEdit={handleEditDates}
          btnEditText={"Edit"}
          handleContinue={handleContinueDates}
          btnOpenText={"Save"}
          title={"Update Start and End Dates"}
          btnContinueDisable={btnContinueDisable}
        >
          <ModifyDates
            selectedRowsData={selectedData}
            siteDates={siteDates}
            modifyDates={modifyDates}
            setBtnContinueDisable={setBtnContinueDisable}
            handleEdit={handleEdit}
          />
        </DialogBox>

        <Dialog
          open={popup}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <closeicon />
          </IconButton>
          <div style={{ marginTop: "30px" }}>
            <DialogContent>
              <Typography style={{ whiteSpace: "pre-line" }}>
                {recordExistResponse}
              </Typography>
            </DialogContent>
          </div>
          <DialogActions>
            <Button
              onClick={handleNo}
              style={{ margin: "0 16px 0 0" }}
              variant="outlined"
            >
              No
            </Button>
            <Button
              onClick={handleYes}
              style={{ margin: "0 16px 0 0" }}
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <DataGrid
          ref={dataGridRef}
          allowColumnResizing={true}
          dataSource={data?.data}
          showBorders={true}
          onSelectionChanged={onSelectionchanged}
          height={calculateGridHeight(260)}
          remoteOperations={true}
          noDataText={data.pending ? "Loading..." : "No Data"}
          btnContinueDisable={btnContinueDisable}
        >
          <Selection
            mode="multiple"
            selectAllMode={"page"}
            showCheckBoxesMode={"always"}
          />
          <Paging enabled={false} />
          <Scrolling columnRenderingMode="virtual" />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <SearchPanel
            visible={true}
            placeholder="Global Search..."
            onTextChange={(e: any) => {
              setSearchTerm(e);
            }}
          />
          <Toolbar>
            <Item location="after">
              <Button
                onClick={onClickRetrySiteCreationWithSelection}
                variant="outlined"
              >
                retry
              </Button>
            </Item>
            <Item location="after">
              <SplitButton
                onSelect={onSelect}
                options={[
                  "ADD",
                  "Legal Entities",
                  "Site Settings",
                  "Site Name",
                  "Update Start and End Dates",
                ]}
                selection={selectedData?.length}
              ></SplitButton>
            </Item>
            <Item location="after">
              <>
                {(appName === "TP" || appName === "CS") && (
                  <SplitButton
                    onSelect={onSelectForIsheet}
                    options={
                      appName === "CS"
                        ? ["Sync Isheets"]
                        : [
                          "Sync Isheets",
                          "Sync Information Request Isheet",
                          "Sync Document Metadata Isheet",
                          "Sync Folder Metadata Isheet",
                          "Sync ISheet IManage Folder",
                        ]
                    }
                    selection={selectedData?.length}
                  ></SplitButton>
                )}
              </>
            </Item>
            <Item location="after">
              <Button
                variant="outlined"
                onClick={onRemoveMapping}
                disabled={selectedData.length > 0 ? false : true}
              >
                Mark as Archived
              </Button>
            </Item>
            <Item location="after">
              <Button
                variant="outlined"
                onClick={onUnarchive}
                disabled={selectedData.length > 0 ? false : true}
              >
                Unarchive
              </Button>
            </Item>
            <Item location="after">
              <Button
                variant="outlined"
                onClick={onAddClientId}
                disabled={selectedData.length > 0 ? false : true}
              >
                Update SiteName
              </Button>
            </Item>
            {/* <Item location="before">
              <div>
                <h4>
                  {selectedData?.length} out of{" "}
                  {ds?.length > 0 ? ds?.length : data.totalCount} records
                  selected
                </h4>
              </div>
            </Item> */}
            <Item
              widget="dxButton"
              options={exportButtonOptions}
              name="alignRight"
            />
            <Item name="searchPanel" location="after" />
            <Item
              widget="dxButton"
              options={refreshButtonOptions}
              name="alignRight"
            />
          </Toolbar>
          <Column
            dataField="hqSiteId"
            caption="SiteID"
            minWidth={70}
            alignment="left"
          ></Column>
          <Column
            dataField="orgId"
            caption="Organisation ID "
            minWidth={70}
            alignment="left"
          ></Column>
          <Column
            dataField="mdmClientId"
            caption="Master ClientID"
            minWidth={135}
            alignment="left"
            cellRender={cellRenderMasterClientId}
          ></Column>
          <Column
            minWidth={300}
            dataField="name"
            caption="Site Name"
            alignment="left"
            cellRender={cellRenderSiteName}
          ></Column>
          <Column
            minWidth={300}
            dataField="templateName"
            caption="Site Template"
            alignment="left"
          ></Column>
          {appName !== "CS" && appName !== "IS" && (
            <Column
              dataField="isCustomPermissionApplied"
              caption="Custom Permissions"
              dataType="boolean"
              width={100}
              alignment="center"
            />
          )}
          <Column
            cellRender={cellRenderForMessage}
            dataField="status"
            caption="Status"
            minWidth={100}
            alignment="left"
          ></Column>
          <Column
            dataField="consentStatus"
            caption="Consent Status"
            dataType="string"
            minWidth={150}
            alignment="left"
            lookup={consentLookup}
          />
          <Column
            cellRender={cellRenderForClientType}
            dataField="Client Type"
            caption="Client Type"
            minWidth={105}
            alignment="left"
          ></Column>
          <Column
            dataField="createdBy"
            caption="Created by "
            minWidth={180}
            alignment="left"
          ></Column>
          <Column
            cellRender={datetime}
            dataField="created"
            caption="Created Date "
            minWidth={180}
            alignment="left"
          ></Column>
          <Column
            dataField="archivedBy"
            caption="Archived by"
            minWidth={180}
            alignment="left"
          ></Column>
          <Column
            cellRender={cellRender}
            dataField="archivedDate"
            caption="Archived Date "
            minWidth={180}
            alignment="left"
          ></Column>
          <Column
            dataField="restoredBy"
            caption="Restored by"
            minWidth={180}
            alignment="left"
          ></Column>
          <Column
            cellRender={cellRenderRestore}
            dataField="restoredDate"
            caption="Restored Date "
            minWidth={180}
            alignment="left"
          ></Column>
        </DataGrid>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "5px 0 0 0",
          }}
        >
          <Pagination
            onChange={(e: any, pageNumber: any) => setpageNumber(pageNumber)}
            count={Math.ceil(data.totalCount / defaultPageSize)}
            variant="outlined"
            shape="rounded"
            page={pageNumber}
          />
        </div>
      </div>
    </div>
  );
}
